// @ts-ignore
import Quill from '@cimpress-technology/quill/core';
import { SizeConverter } from '../../RichTextField/IRichTextFieldOptions';
import { DEFAULT_SIZE_CONVERTER } from './helpers';

export const { StyleAttributor, Scope } = Quill.import('parchment');
class SizeAttributor extends StyleAttributor {
    public converter?: SizeConverter = undefined;

    public add(node: HTMLElement, value: number) {
        if (!super.canAdd(node, value)) {
            return false;
        }

        // eslint-disable-next-line no-param-reassign
        node.dataset.size = JSON.stringify({ value });

        const converted = (this.converter || DEFAULT_SIZE_CONVERTER)(value);
        return super.add(node, converted);
    }

    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): number | string {
        // This statement is needed because the list marker font size attributor conflicts with this attributor since they listen to the same property.
        if (!node.dataset.size) {
            return '';
        }
        const { value } = JSON.parse(node.dataset.size!);
        return value;
    }
}

// @ts-ignore
export default new SizeAttributor('fontSize', 'font-size', { scope: Scope.INLINE });
// @ts-ignore
export const BlockSizeAttributor = new SizeAttributor('blockFontSize', 'font-size', { scope: Scope.BLOCK });
